import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { NotificationStatItem } from "@ryde/controls";
import {
  notificationPriorities,
  notificationStatsSelector,
} from "@ryde/shared";

import { NotificationStatsStyled } from "./notification-stats.styled";

export const NotificationStats: FC = () => {
  const notificationStats = useRecoilValue(notificationStatsSelector);
  const { t } = useTranslation();
  return (
    <NotificationStatsStyled>
      {notificationPriorities.map(notificationPriorityKey => (
        <span key={notificationPriorityKey} className="NotificationStats-Item">
          <NotificationStatItem
            label={notificationStats[notificationPriorityKey]}
          />{" "}
          {t(`notification.stats.${notificationPriorityKey}`)}
        </span>
      ))}
    </NotificationStatsStyled>
  );
};
